
<form (ngSubmit)="onSubmit()" #loginForm="ngForm">
  <div class="container mt-5">
    <div class="row d-flex justify-content-center">
      <div class="col-md-6">
        <div class="card px-5 py-5" id="form1">
          <div class="form-data" v-if="!submitted">
            <div class="forms-inputs mb-4">
              <span>Email</span>
              <input type="email" id="userName" name="userName" class="form-control form-control-lg"
                placeholder="Email Address" required [(ngModel)]="login.username" />


            </div>
            <div class="forms-inputs mb-4">
              <span>Password</span> <input type="password" id="password" name="password" class="form-control form-control-lg"
              placeholder="Password" required [(ngModel)]="login.password" />
          </div>
          <div class="mb-3">
            <button type="submit" class="btn btn-primary btn-lg"
              style="padding-left: 2.5rem; padding-right: 2.5rem;">
              Login
            </button>
          </div>
          <div class="mb-3">
            @if (firstlogin != 'true') {
              <button type="button" (click)="forgotPassword()" class="btn btn-link"
                style="padding-right: 2.5rem;">
                Forgot Password
              </button>
            }
            @if (firstlogin == 'true') {
              <button type="button" (click)="resetPassword()" class="btn btn-link"
                style="padding-left: 2.5rem; padding-right: 2.5rem;">
                Reset Password
              </button>
            }
          </div>
          @if (firstlogin != 'true') {
            <div class="mb-3">
            </div>
          }
          <div>
            {{errorMessage}}
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</form>
